import {
  StyledNotePreviewContainer,
  StyledContentArea,
  StyledContentPadding,
} from "./note-preview-container.style";
import { MDSNotePreviewContainerProps } from "./note-preview-container.types";
import { MDSNotePreviewContainerFooter } from "./footer/note-preview-container-footer";

export const MDSNotePreviewContainer = ({
  title,
  createdAt,
  modifiedAt,
  secondaryLabel,
  authorNames,
  shouldScroll = true,
  updateOnly = false,
  width,
  variant,
  className,
  onClick,
  children,
}: MDSNotePreviewContainerProps) => {
  return (
    <StyledNotePreviewContainer
      variant={variant}
      className={className}
      width={width}
      onClick={onClick}
      data-mds-name="note-preview-container"
    >
      <StyledContentArea shouldScroll={shouldScroll}>
        {children}
        <StyledContentPadding />
      </StyledContentArea>
      <MDSNotePreviewContainerFooter
        title={title}
        createdAt={createdAt}
        modifiedAt={modifiedAt}
        updateOnly={updateOnly}
        authorNames={authorNames}
        secondaryLabel={secondaryLabel}
      />
    </StyledNotePreviewContainer>
  );
};
